// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1PzTa","right":"Footer_right__2ABO2","buttons":"Footer_buttons__sjZUw"};